import { AccountPermission } from 'modules/permissions/constants';
import { EMilliSeconds } from 'modules/common/constants/const';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useCheckAccountPermission } from 'modules/account/hooks/useCheckAccountPermission';

import { useFetchMySubscriptionsQuery } from '../actions/subscriptions/fetchMySubscriptions';

export interface MySubscriptionsParams {
  skipFetching?: boolean;
}

export const useMySubscriptions = ({
  skipFetching = false,
}: MySubscriptionsParams | void = {}) => {
  const { group } = useAccount();
  const { isPremium } = useAccountStatus();

  const hasAccess = useCheckAccountPermission({
    permission: AccountPermission.Billing,
  });

  useFetchMySubscriptionsQuery(
    { group },
    {
      skip: skipFetching || !(isPremium || hasAccess),
      pollingInterval: 30 * EMilliSeconds.Second,
    },
  );
};
